import React from "react";

import { GetStaticProps } from "next";

import ApplicationLayout from "components/ApplicationLayout";
import Navbar from "components/Navbar";
import PageContent from "components/PageContent";
import SharedFooter from "components/SharedFooter";

import { Page } from "types/page";
import Hero from "components/home/Hero";
import EasyAsInstalled from "components/home/EasyAsInstalled";
import YourPlayground from "components/home/YourPlayground";
import Teams from "components/home/Teams";
import Features from "components/home/Features";
import SocialFooter from "components/SocialFooter";
import ReadyForTakeOff from "components/ReadyForTakeOff";
import Container from "components/Container";
import MoreFocus from "components/home/MoreFocus";
import { fetchLatestRaycastVersion } from "lib/api";

export const getStaticProps: GetStaticProps = async () => {
  const latestVersion = await fetchLatestRaycastVersion();

  return {
    props: {
      latestVersion: latestVersion.version,
    },
  };
};

const Index: Page<{ latestVersion: string }> = ({ latestVersion }) => {
  return (
    <div>
      <Hero latestVersion={latestVersion} />
      <EasyAsInstalled />
      <YourPlayground />
      <Teams />
      <Features />
      <MoreFocus />
      <Container size="lg">
        <ReadyForTakeOff />
        <SocialFooter />
      </Container>
    </div>
  );
};

Index.getLayout = (page) => {
  return (
    <ApplicationLayout>
      <Navbar />
      <PageContent>{page}</PageContent>
      <SharedFooter />
    </ApplicationLayout>
  );
};

export default Index;
